// extracted by mini-css-extract-plugin
module.exports = {"root":"Details_root__LQwYE","card":"Details_card__SfFEq","image":"Details_image__TJA1J","list":"Details_list__Oabcc"};